export const InputType = {
  PhoneNumber: 'PhoneNumber',
  Mileage: 'Mileage',
  Password: 'Password',
  VinNumber: 'VinNumber',
  Currency: 'Currency',
  Email: 'Email',
  ZipCode: 'ZipCode',
  FirstName: 'FirstName',
  LastName: 'LastName',
  Comment: 'Comment',
  City: 'City',
  StreetAddress: 'StreetAddress'
};
export const InputValidationErrorCode = {
  FormatError: 0,
  LengthError: 1,
  RequiredError: 2,
  NumericalError: 3
};
export const DefaultValidationErrorMessages = {
  [InputType.FirstName]: {
    [InputValidationErrorCode.FormatError]: 'First Name contains invalid character.',
    [InputValidationErrorCode.LengthError]: 'First Name must be less than or equal 50 characters.',
    [InputValidationErrorCode.RequiredError]: 'This field is required.'
  },
  [InputType.LastName]: {
    [InputValidationErrorCode.FormatError]: 'Last Name contains invalid character.',
    [InputValidationErrorCode.LengthError]: 'Last Name must be less than or equal 50 characters.',
    [InputValidationErrorCode.RequiredError]: 'This field is required.'
  },
  [InputType.Email]: {
    [InputValidationErrorCode.FormatError]: 'Invalid Email format.',
    [InputValidationErrorCode.RequiredError]: 'This field is required.',
    [InputValidationErrorCode.LengthError]: 'Email must be less than or equal 50 characters.'
  },
  [InputType.PhoneNumber]: {
    [InputValidationErrorCode.FormatError]: 'Invalid Phone Number format.',
    [InputValidationErrorCode.LengthError]: 'Phone Number must be 10 digits.',
    [InputValidationErrorCode.RequiredError]: 'This field is required.',
    [InputValidationErrorCode.NumericalError]: 'Phone Number must be digit only.'
  }
};
//# sourceMappingURL=InputType.js.map